/*
 * @Author: zhuyan 
 * @Date: 2021-11-24 17:07:42 
 * 公司资产 => 软件账号管理
 */

 import React from 'react'
 import { Switch, Route } from 'react-router-dom'
 import Software from './Software'
 import SoftDetails from './module/SoftDetails'
 
 const SystemIndex = ({ match, history }) => {
 
   return (
     <Switch>
			<Route path={match.path + '/detail'} component={SoftDetails} />
       <Route component={Software} />
     </Switch>
   )
 }
 
 export default SystemIndex